import $ from "jquery";
import { mountVueComponent } from "@/app";
import EmbedVideoLightboxProxy from "@/components/proxy/EmbedVideoLightboxProxy.vue";
import { useAppStore } from "@/stores/app";

window.addEventListener("vueComponentRootMounted", () => {
  const store = useAppStore();

  $("[data-open-lightbox]").on("click", function (event) {
    event.preventDefault();
    const $this = $(this);

    $("body").addClass("no-scroll");

    store.lightbox.open = true;
    store.lightbox.embedUrl = $this.attr("href");
  });

  store.$onAction(({ name }) => {
    if (name === "closeLightbox") {
      $("body").removeClass("no-scroll");
    }
  });
});

const $lightboxContainer = $("#lightbox-component");

if ($lightboxContainer.length === 0) {
  $("body").append('<div id="lightbox-component"></div>');
  mountVueComponent(
    EmbedVideoLightboxProxy,
    document.querySelector("#lightbox-component")
  );
}
